import {Component, OnInit}                  from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MatDialog, MatDialogRef}            from '@angular/material/dialog';
import {MatSnackBar}                        from '@angular/material/snack-bar';
import {MatTableDataSource}                 from '@angular/material/table';
import {ActivatedRoute, Router}             from '@angular/router';
import {PriceUploadModalComponent}          from '@src/app/admin/products/components/price-upload-modal/price-upload-modal.component';
import {Breadcrumb}                         from '@src/app/shared/models/breadcrumb.model';
import {Button}                             from '@src/app/shared/models/button.model';
import {ApiService}                         from '@src/app/shared/services/api.service';
import {query}                              from 'js-query-builder';
import {DialogComponent}                    from '@src/app/shared/components/dialog/dialog.component';

@Component({
    standalone: false,
    selector: 'app-create',
    templateUrl: './products-form.component.html',
    styleUrls: ['./products-form.component.css']
})
export class ProductsFormComponent implements OnInit
{
    public displayedColumns: string[] = ['manufacturer', 'operative_cost', 'subcontractor_cost', 'material_cost', 'sell_price', 'start_at', 'created_by', 'created_at', 'actions'];

    public productManufacturers: MatTableDataSource<any> = new MatTableDataSource();

    public create: boolean = true;

    public productMeasures: any[] = [];

    public product: any;

    public productForm: FormGroup;

    public breadcrumbs: Breadcrumb[] = [
        {
            title: 'Home',
            url: '/app/',
            active: false
        },
        {
            title: 'Products',
            active: false,
            url: '/app/products/',
        },
        {
            title: 'Add Product',
            active: true,
        }
    ];

    public buttons: Button[] = [
        {
            type: 'button',
            material: 'flat',
            color: 'primary',
            title: 'Save Product',
            permission: 'add_products',
            callback: () => {
                this.onSubmit();
            }
        }
    ];

    public constructor(
        private dialog: MatDialog,
        private activatedRoute: ActivatedRoute,
        private apiService: ApiService,
        private router: Router,
        private fb: FormBuilder,
        private snackBar: MatSnackBar,
    )
    {
        this.productForm = this.fb.group({
            name: [null, Validators.required],
            status_id: [1, Validators.required],
            measure_id: [null, Validators.required],
            display_measure: [null]
        });
    }

    public ngOnInit(): void
    {
        this.apiService.get('products/measures?fields[product_measures]=id,unit,symbol').subscribe(
            result => this.productMeasures = result.data,
            error => this.apiService.handleError(error)
        );

        this.activatedRoute.params.subscribe(params => {
            if (params['id']) {
                this.create = false;
                this.getProductData(params['id']);
            }
        });
    }

    public onSubmit(): void
    {
        if (this.productForm.valid) {
            if (this.product) {
                this.apiService.update('products', this.product.id, this.productForm.value).subscribe(
                    result => this.router.navigateByUrl(`/app/products`),
                    error => this.apiService.handleError(error)
                );
            } else {
                this.apiService.create('products', this.productForm.value).subscribe(
                    result => this.router.navigateByUrl(`/app/products/edit/${result.data.id}`),
                    error => this.apiService.handleError(error)
                );
            }
        }
    }

    public pricingPage(manufacturer = null): void
    {
        this.router.navigateByUrl(`/app/products/edit/${this.product.id}/pricing/${manufacturer?.default_price?.manufacturer_product_id ?? 'create'}`, {
            state: {
                product: this.product,
                price: manufacturer?.default_price
            }
        });
    }

    public onArchive(id): void
    {
        this.apiService.delete(`products/manufacturer`, id).subscribe(
            () => this.getProductData(this.product.id),
            error => {
                this.apiService.handleError(error.message);
                this.snackBar.open('You cannot delete a manufacturer product link that is in use on existing sites.', 'Ok.', {duration: 4000});
            }
        );
    }

    public confirmArchiveManufacturerFromProduct(id: number): void
    {
        const confirmDialogRef = this.dialog.open(DialogComponent, {
            data: {
                title: 'Archive Manufacturer',
                message: 'Are you sure you want to archive this manufacturer from this product? You can\'t undo this action.',
                type: 'danger-outline',
                confirmButtonLabel: 'Archive'
            }
        });

        confirmDialogRef.afterClosed().subscribe(confirm => {
            if (confirm) {
                this.onArchive(id);
            }
        });
    }

    public getProductData(id): void
    {
        const url = query(`products/${id}}`).build();
        this.apiService.get(url).subscribe(
            result => {
                this.product = result.data;
                this.productManufacturers = new MatTableDataSource(this.product.manufacturers);

                this.productForm = this.fb.group({
                    name: [this.product.name, Validators.required],
                    status_id: [this.product.status.id, Validators.required],
                    measure_id: [this.product.measure.id, Validators.required],
                    display_measure: [this.product.display_measure],
                });

                this.breadcrumbs = [
                    {
                        title: 'Home',
                        url: '/app/',
                        active: false
                    },
                    {
                        title: 'Products',
                        active: false,
                        url: '/app/products/',
                    },
                    {
                        title: `${this.product.name}`,
                        active: true,
                    }
                ];
            },
            error => this.apiService.handleError(error)
        );
    }

    public uploadPrices(manufacturer): void
    {
        const priceUploadDialog: MatDialogRef<PriceUploadModalComponent> = this.dialog.open(PriceUploadModalComponent, {
            width: '65%',
            panelClass: 'mobile-width',
            disableClose: true,
            data: {
                price: manufacturer?.default_price,
                product: this.product,
                manufacturerProductId: manufacturer?.default_price?.manufacturer_product_id,
            }
        });

        priceUploadDialog.afterClosed().subscribe((data): void => {
        });
    }
}
